module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('h2', [_vm._v("Our partners")]), _vm._v(" "), _c('div', {
    staticClass: "partners-pictures"
  }, [_c('a', {
    attrs: {
      "href": "https://research.qut.edu.au/designlab/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.logPartnerClicks('QUT')
      }
    }
  }, [_c('div', {
    staticClass: "partner",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/DL-Blue-Logo-white-background.jpg')"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://cbcs.centre.uq.edu.au/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.logPartnerClicks('UQ')
      }
    }
  }, [_c('div', {
    staticClass: "partner",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4796/dist/assets/img/UQlogo-Purple-rgb.png')"
    }
  })])]), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To learn more about our partners "), _c('a', {
    attrs: {
      "href": "https://www.wwf.org.au/news/blogs/thanks-to-our-my-backyard-partners",
      "target": "_blank"
    }
  }, [_vm._v("click here")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4311c544","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/Partners.vue
// module id = 797
// module chunks = 0